/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MakePrimaryAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function MakePrimaryAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/MakePrimaryAction"
  
}) {
let payorIsPrimaryValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'is_primary',
})
let paymentPlanPayorsValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'payors',
})
let constantData = 1
let aggregateData = fromAggregate.lengthEquals(paymentPlanPayorsValueData, constantData)
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginLeft="auto"
 data="payor.is_primary"
 value={payorIsPrimaryValueData}
 onChange={onChange}
 data="payment_plan.payors"
 data={1}
 aggregate="/Data/aggregate.js lengthEquals"
 disabled={aggregateData}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Assign as primary payor"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}